var _circle, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconCoinColored(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 8,
    cy: 8,
    r: 6.75,
    fill: "#FCE3AE",
    stroke: "#F9CC6F",
    strokeWidth: 2.5
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.70264 4.4375H8.51656C9.05349 4.4375 9.51585 4.54025 9.90363 4.74574C10.2947 4.94792 10.5914 5.23295 10.7935 5.60085C10.9957 5.96875 11.0968 6.39134 11.0968 6.86861C11.0968 7.34919 10.9924 7.77178 10.7836 8.13636C10.5781 8.49763 10.2782 8.78101 9.88374 8.98651C9.49265 9.18868 9.02532 9.28977 8.48176 9.28977H6.6721V8.08665H8.24809C8.53644 8.08665 8.77839 8.03693 8.97394 7.9375C9.17281 7.83475 9.3203 7.69223 9.41641 7.50994C9.51253 7.32765 9.56059 7.11387 9.56059 6.86861C9.56059 6.62334 9.51253 6.41122 9.41641 6.23224C9.3203 6.04995 9.17281 5.91075 8.97394 5.81463C8.77839 5.7152 8.53479 5.66548 8.24312 5.66548H7.19411V11.6364H5.70264V4.4375Z",
    fill: "#FAAE1D"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconCoinColored);
export default __webpack_public_path__ + "static/media/icon_coin_colored.39ed2e686e6eb37b9d8467ff78510151.svg";
export { ForwardRef as ReactComponent };